import { PopoverService } from '../../tn.popover/service.tn.popover';
import helpPopoverTemplate from './helpPopover.html';

HelpPopover.$inject = ['$tnPopover'];
export function HelpPopover($tnPopover: PopoverService) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            popoverClass: '@?',
        },
        link: function (scope, element) {
            scope.popoverClass = scope.popoverClass || '';
            const $popoverEl = element.find('div.popover-help');
            scope.helpPopover = $tnPopover.popoverXS($popoverEl);
        },
        template: helpPopoverTemplate,
    };
}
